import { AnyAppEvent, AppEvent } from "../appEvent.types";

const eventName = "visitor-favorite-notification" as const;

export type VisitorFavoriteNotificationEventData = {
  visitorId: string;
  structureId: string;
  structureAdminId: string;
  visitorName: string;
  eventName: string;
  eventImageId: string | null;
};

export type VisitorFavoriteNotificationEvent = AppEvent<
  typeof eventName,
  VisitorFavoriteNotificationEventData
>;

export const isVisitorFavoriteNotificationEvent = (
  event: AnyAppEvent
): event is VisitorFavoriteNotificationEvent => event.name === eventName;

export { eventName as visitorFavoriteNotification };
